















































import BaseComponent from '@/components/base-component.vue';
import VisitsEvolutionCharts from '@/components/crm/visits-evolution/visits-evol-chart.vue';
import CrmVisitEvolutionFilters from '@/components/crm/visits-evolution/visits-evol-filters.vue';
import VisitsEvolutionVisitorsCharts from '@/components/crm/visits-evolution/visits-evol-visitors-chart.vue';
import VisitsEvolutionVisitorsTable from '@/components/crm/visits-evolution/visits-evol-visitors-table.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import { VisitaEvolucaoFiltrosDTO } from '@/interfaces/crm-visit-evolution';
import { listCrmVisitEvolutionData, listCrmVisitEvolutionVisitorsData } from '@/services/crm-visit-evolution';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    UiFilterContainer,
    VisitsEvolutionCharts,
    VisitsEvolutionVisitorsCharts,
    VisitsEvolutionVisitorsTable,
    CrmVisitEvolutionFilters
  }
})
export default class VisitEvolution extends BaseComponent {
  kpis = [];
  loadingKpis = false;

  kpisVisitors = [];
  loadingKpisVisitors = false;

  filters = null;

  mounted() {
  }

  @Watch('months')
  watchMonths(v) {
    this.loadAll();
  }

  @Watch('groupBy')
  watchgroupBy(v) {
    this.loadAll();
  }

  onFilter(f) {
    this.filters = f;
    this.loadAll();
  }

  loadAll() {
    this.loadEvolution();
    this.loadEvolutionVisitors();
  }

  loadEvolution() {
    this.loadingKpis = true;
    let parm = this.buildParms();
    listCrmVisitEvolutionData(parm).subscribe(
      (res) => {
        this.kpis = res;
        this.loadingKpis = false;
      },
      (error) => {
        this.loadingKpis = false;
        this.showToastApiError(error);
      }
    );
  }
  loadEvolutionVisitors() {
    this.loadingKpisVisitors = true;
    let parm = this.buildParms();
    listCrmVisitEvolutionVisitorsData(parm).subscribe(
      (res) => {
        this.kpisVisitors = res;
        this.loadingKpisVisitors = false;
      },
      (error) => {
        this.loadingKpisVisitors = false;
        this.showToastApiError(error);
      }
    );
  }

  buildParms() {
    let parm = new VisitaEvolucaoFiltrosDTO();
    parm.qtdeMeses = this.filters.months;
    parm.semanal = this.filters.groupBy.id != 'M';
    parm.idsVisitantes = this.filters.idsVisitantes;
    return parm;
  }
}
